import axios from '../requester';
import { API } from '../constants/api-urls';
export const getCommitStats = async body => axios.post(API.COMMITS_PATH, body);
